module.exports = __webpack_public_path__ + "img/icon.ec41b936.png";